module.exports = __webpack_public_path__ + "static/media/text_01.8d211c3e.png";